<template lang="html">
  <v-container class='fluid'>

    <v-dialog v-model="dialogConfirmaReprovacao" max-width="600px" persistent>
      <v-card>
        <v-card-title class="headline font-weight-medium grey lighten-4">
          Confirmação de Reprovação
        </v-card-title>

        <v-card-text class="pt-4">
          <p class="text-body-1 mb-4">
            <template v-if="projetoSelecionado">
              Deseja reprovar o relatório do projeto <strong>{{ projetoSelecionado.titulo }}</strong>?<br><br>
              O(a) coordenador(a) <strong>{{ projetoSelecionado.nomeCoordenador }}</strong> será suspenso(a) por 1 ano.
            </template>
            <template v-else>
              <p>Carregando informações do projeto...</p>
            </template>

          </p>

          <v-text-field
            v-model="dataInicioSuspensao"
            label="Data de início da suspensão"
            type="date"
            outlined
            dense
            required
            prepend-icon="event"
          ></v-text-field>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions class="justify-end">
          <v-btn text color="grey darken-1" @click="dialogConfirmaReprovacao = false">
            Não
          </v-btn>
          <v-btn
            color="red darken-1"
            dark
            :disabled="!dataInicioSuspensao"
            @click="reprovarRelatorioESuspenderCoordenador(projetoSelecionado.idProjeto)"
          >
            Sim, reprovar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>




    <v-layout align-center justify-center>
      <v-flex xs10>

        <v-card class="text-xs-center" v-if="administrador === true">
          <basic-toolbar :title="'Reprovação de Relatório com Suspensão de Coordenador'"></basic-toolbar>
          <v-card-title>
            <v-spacer></v-spacer>
            <v-text-field append-icon="filter_list" label="Filtrar resultados" v-model="search"></v-text-field>
          </v-card-title>
          <v-card-text>
            <v-data-table
              :headers="headers"
              :items="listaProjetos"
              :search="search"
              :no-data-text="'Nenhuma ação'"
              must-sort
              :sort-by.sync="sortBy"
              :sort-desc.sync="sortDesc"
              :items-per-page="itemsPerPage"
              :footer-props="{itemsPerPageText: 'Linhas por página', itemsPerPageOptions: opcoesPaginacao}"
            >
              <template v-slot:item.titulo="props">
                <router-link :to="{ name: 'ProjetoFormulario', params: { idProjeto: props.item.idProjeto }}">{{props.item.titulo}}</router-link>
              </template>
              <template v-slot:item.opcoes="props">
                <!-- Ícone de "Devolver" -->
                <c-tooltip-btn
                icon="not_interested"
                color="red"
                tooltip="Reprovar Relatório"
                @click="abreDialog(props.item)"
                ></c-tooltip-btn>
                <!--v-btn color="primary" text icon @click="reprovarRelatorio(props.item.idProjeto)" >
                  <v-icon>delete</v-icon>
                </!--v-btn-->
              </template>
              <template slot="footer.page-text" slot-scope="{ pageStart, pageStop }">
                Mostrando {{ pageStart }} a {{ pageStop }} de {{ listaProjetos.length }} ações
              </template>
            </v-data-table>
            <br>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
  import BasicToolbar from '@/components/toolbars/basic-toolbar'
  import ToolTip from '@/components/app-layouts/app-tooltip/tooltip'
  import TootipButton from '@/components/c-tooltip-btn'
  import projetos from '@/utils/projetos'
  import { mapGetters, mapActions } from 'vuex'

  export default {
    props: ['idProjeto'],
    data: () => ({
      dialogConfirmaReprovacao: false,
      dataInicioSuspensao: null,
      projetoSelecionado: null,
      listaProjetos: [],
      search: null,
      sortBy: 'dtCriacao',
      sortDesc: true,
      itemsPerPage: -1,
      opcoesPaginacao: [ 10, 25, 50, {text: 'Todas', value: -1} ],
      headers: [
        { text: 'Número', align: 'center', value: 'idProjeto' },
        { text: 'Título', align: 'center', value: 'titulo' },
        { text: 'Classificação Primária', align: 'center', value: 'classificacaoPrimaria' },
        { text: 'Classificação Secundária', align: 'center', value: 'classificacaoSecundaria' },
        { text: 'Situação', align: 'center', value: 'situacao' },
        { text: 'Coordenador', align: 'center', value: 'nomeCoordenador' },
        { text: 'Opções', align: 'center', value: 'opcoes' }
      ]
    }),
    computed: {
      ...mapGetters('auth', ['logged', 'username', 'nome', 'administrador', 'usuarioPROEX'])
    },
    methods: {
      ...mapActions('ui', ['SHOW_GLOBAL_LOADING', 'HIDE_GLOBAL_LOADING', 'SHOW_SNACKBAR']),
      reprovarRelatorioESuspenderCoordenador: function (idProjeto) {
        this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Reprovando relatório...' })

        const payload = {
          dtInicioSuspensao: this.dataInicioSuspensao
        }

        projetos.postReprovarRelatorioComSuspensaoDeCoordenador(idProjeto, payload)
        .then(response => {
          this.SHOW_SNACKBAR({snackbarType: 'success', snackbarText: response.body.mensagem})
          for (let i = 0; i < this.listaProjetos.length; i++) {
            if (this.listaProjetos[i].idProjeto === idProjeto) {
              this.listaProjetos.splice(i, 1)
              i--
            }
          }
        })
        .catch(error => {
          console.log('Erro ao mandar o request' + error)
          this.SHOW_SNACKBAR({snackbarType: 'error', snackbarText: error.body.mensagem})
        })
        .finally(() => {
          this.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Reprovando Relatório...' })
          this.dialogConfirmaReprovacao = false
        })
      },
      abreDialog (projeto) {
        this.projetoSelecionado = projeto
        this.dataInicioSuspensao = null
        this.dialogConfirmaReprovacao = true
      }
    },
    mounted () {
      this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando ações.' })
      projetos.getProjetosComRelatorioReprovavel()
      .then(response => {
        this.listaProjetos = response.data.slice()
      })
      .catch(error => {
        console.log('Erro ao mandar o request' + error)
        this.listaProjetos = []
      })
      .finally(() => {
        this.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando ações.' })
      })
    },
    components: {
      'basic-toolbar': BasicToolbar,
      'c-tooltip-btn': TootipButton,
      'tooltip': ToolTip
    }
  }
</script>



// WEBPACK FOOTER //
// reprovar-relatorios-suspensao-coordenador.vue?099bb832